require('dotenv').config();

const portalBaseUrl = window.location.origin;
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
const iconsBaseUrl = process.env.REACT_APP_ICONS_BASE_URL;
const adminPortalBaseUrl = process.env.REACT_APP_ADMIN_PORTAL_BASE_URL;
const signInUserFlow = process.env.REACT_APP_SIGN_IN_USER_FLOW;
const webClientId = process.env.REACT_APP_B2C_WEB_CLIENT_ID;
const apiClientId = process.env.REACT_APP_B2C_API_CLIENT_ID;
const aoiLayerChunkSize = process.env.REACT_APP_AOI_LAYER_CHUNK_SIZE;
const aoiLayerMaxThread = process.env.REACT_APP_AOI_LAYER_MAX_THREAD;
const enquiryFeatureFlag = process.env.REACT_APP_ENQUIRY_FEATURE_FLAG === 'true';
const printPreviewFeatureFlag = process.env.REACT_APP_PRINT_PREVIEW === 'true';
const electricitySymbologyFeatureFlag = process.env.REACT_APP_ELECTRICITY_SYMBOLOGY_FEATURE_FLAG === 'true';
const electricitySymbologyFeatureFlagDate = process.env.REACT_APP_ELECTRICITY_SYMBOLOGY_FEATURE_FLAG_DATE;
const linearSearchFeatureFlag = process.env.REACT_APP_LINEAR_SEARCH_FEATURE_FLAG === 'true';
const serviceDeskTelephone = process.env.REACT_APP_SERVICE_DESK_TELEPHONE;
const serviceDeskEmail = process.env.REACT_APP_SERVICE_DESK_EMAIL;

export {
    apiBaseUrl,
    iconsBaseUrl,
    portalBaseUrl,
    adminPortalBaseUrl,
    signInUserFlow,
    webClientId,
    apiClientId,
    aoiLayerChunkSize,
    aoiLayerMaxThread,
    enquiryFeatureFlag,
    printPreviewFeatureFlag,
    electricitySymbologyFeatureFlag,
    electricitySymbologyFeatureFlagDate,
    linearSearchFeatureFlag,
    serviceDeskTelephone,
    serviceDeskEmail
};
